import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { AuthService } from "@shared/auth/auth.service";
import { SharedService } from "@shared/services/shared.service";
import { IBusinessFollowUpSiteVisitViewModel, IBusinessInitialSiteVisitViewModel, IBusinessSiteVisitViewModel } from "app/models/complaints/siteVisit";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { SiteVisitService } from "app/services/complaint/siteVisit.service";
import { FollowupVisitEditComponent } from "../followupVisitEdit/followupVisitEdit.component";
import { Subscription } from "rxjs";

@Component({
  selector: 'shared-followupSiteVisit',
  templateUrl: './followupSiteVisit.component.html',
  styleUrls: ['./followupSiteVisit.component.scss']
})

export class FollowupSiteVisitComponent implements OnInit {

  @Input() parentPanel: number = 0;

  visitSubscription: Subscription;
  complaintId: number = 0;

  followupLength: number = 0;
  businessId: number = 0;
  isAdmin: boolean = false;
  siteVisit: number = 0;
  followupVisitList: IBusinessFollowUpSiteVisitViewModel[] = [];
  siteVisits: IBusinessSiteVisitViewModel = {} as IBusinessSiteVisitViewModel;

  displayedColumns: string[] = ['action', 'complaintId', 'requiredImplementationDate', 'requiredVisitDate', 'followupDate',
    'followupConducted', 'remediationResult', 'siteVisitNotes'];
  dataSource = new MatTableDataSource<IBusinessFollowUpSiteVisitViewModel>(this.followupVisitList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(
    private siteVisitService: SiteVisitService,
    private complaintService: ComplaintService,
    private sharedService: SharedService,
    private authService: AuthService,
    private modalService: MatDialog
  ) {

  }

  ngOnInit(): void {
    this.isAdmin = this.authService.isAdmin;

    this.visitSubscription = this.siteVisitService.updateSiteVistEvent.subscribe((data: number) => {
      this.followupVisitList = this.siteVisitService.siteVisit.followupSiteVisits;
      this.dataSource.data = this.followupVisitList;
      this.complaintId = this.siteVisitService.complaintId;
      this.followupLength = this.followupVisitList.length;
    });
  }
  ngOnDestroy() {
    this.visitSubscription.unsubscribe();
  }

  removeFollowupSiteVisit(visit: IBusinessInitialSiteVisitViewModel) {
    this.sharedService.openConfirm("Are you sure you want to delete this visit?");

    this.sharedService.confirmed().subscribe(
      confirmed => {
        if (confirmed) {
          this.siteVisitService.deleteSiteVisits(visit.id, this.siteVisitService.statusFollowup).subscribe({
            next: response => {
              this.siteVisitService.getSiteVisitData(this.siteVisitService.siteVisit.businessId);
              this.sharedService.toastr.success("Site Visit deleted.");
            },
            error: e => {
              this.sharedService.toastr.error("Could not delete site visit data.");
            },
          });
        }
      }
    );
  }

  editFollowupSiteVisit(visit: IBusinessFollowUpSiteVisitViewModel) {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = true;
    config.minWidth = 600;
    config.maxWidth = 600;
    config.maxHeight = 800;
    config.data = {
      siteVisit: visit,
      followupVisitItems: this.followupVisitList
    };
    const dialogRef = this.modalService.open(FollowupVisitEditComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.siteVisitService.getSiteVisitData(this.siteVisitService.siteVisit.businessId);
        }
      },
      error => this.sharedService.toastr.error("Error"),
      () => { }
    );
  }

  gotoComplaint(complaint: IBusinessFollowUpSiteVisitViewModel) {
    this.complaintService.complaintId = complaint.complaintId;
    this.complaintService.complaintTab = 4;
    this.complaintService.complaintVisitTab = 1;
    this.sharedService.doRedirect('complaint/complaint/' + complaint.complaintId);
  }
}